import React from 'react';
import { FaEnvelope, FaInstagram, FaLinkedin, FaLocationDot, FaPhone } from 'react-icons/fa6';
import styles from './Footer.module.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.brandBlock}>
          <div className={styles.logo} aria-hidden="true">
            <img src="/logo.png" alt="DJ DevStudio" loading="lazy" />
          </div>
          <p>
            Transformo empresas de todos os segmentos em referências digitais com sites que geram
            credibilidade, leads e oportunidades reais.
          </p>
        </div>

        <div className={styles.infoBlock}>
          <h3>Contato</h3>
          <ul>
            <li>
              <FaPhone aria-hidden="true" />
              <a href="tel:+5535999564940">(35) 99956-4940</a>
            </li>
            <li>
              <FaEnvelope aria-hidden="true" />
              <a href="mailto:contato@djdevstudio.com">contato@djdevstudio.com</a>
            </li>
            <li>
              <FaLocationDot aria-hidden="true" />
              <span>Campo Belo • MG • Atendo todo o Brasil</span>
            </li>
          </ul>
        </div>

        <div className={styles.linksBlock}>
          <h3>Links úteis</h3>
          <ul>
            <li><a href="#como-funciona">Serviços</a></li>
            <li><a href="#depoimentos">Depoimentos</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
        </div>

        <div className={styles.socialBlock}>
          <h3>Me acompanhe</h3>
          <div className={styles.socialLinks}>
            <a href="https://www.instagram.com/jaovictordev/" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/dev-joao-victor/" aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href="mailto:contato@djdevstudio.com" aria-label="E-mail">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <span>&copy; {currentYear} João Victor | Dev. Todos os direitos reservados.</span>
        <a href="#privacidade">Política de privacidade</a>
      </div>
    </footer>
  );
}
